import { Component, OnInit, Input, ViewChild, ElementRef, TemplateRef, Output, EventEmitter, AfterViewInit, AfterViewChecked, SimpleChanges, OnChanges, PipeTransform, HostListener, inject } from '@angular/core';
import * as moment from 'moment-timezone';
import { DatatableService } from '../datatable.service';
import { DatatableFilter } from '../datatable-filter';
import { DatatableSort } from '../datatable-sort';
import { DatatableColumn } from '../datatable-column';
import { DatatableColumnWidth } from '../datatable-column-width';
import { DatatableRequest } from '../datatable-request';
import { DatatableComponent as NgxDatableComponent, NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { HttpErrorResponse } from '@angular/common/http';
import { ValidationService } from '../../validation/validation.service';
import { DatatableStaticTemplateType } from '../datatable-static-template';
import { DialogService } from '../../dialog/dialog.service';
import { EnvironmentService } from '../../environment/environment.service';
import { GenericDialogData } from '../../dialog/generic-dialog/generic-dialog-data';
import { IdentityService } from '../../auth/identity.service';
import { DatatableFilterComponent } from '../datatable-filter/datatable-filter.component';
import { Subscription } from 'rxjs';
import * as fileSaver from 'file-saver';
import { AppInsightsService } from 'projects/bis-shared/src/lib/logging/app-insights-service';
import { Router } from '@angular/router';
import { SnackbarService } from '../../snackbar/snackbar.service';
import { KeyConstant } from '../../utility/key-constants';
import { ValidationContainerComponent } from '../../validation/validation-container.component';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { EasternMomemtPipe } from '../../utility/local-moment.pipe';
import { DateFormatPipe } from '../../utility/date-format.pipe';
import { UTCMomentPipe } from '../../utility/utc-moment.pipe';
import { DateTimeFormatPipe } from '../../utility/date-time-format.pipe';
import { RowDetailVisiblePipe } from '../row-detail-visible-pipe';
import { YesNoPipe } from '../../utility/yes-no.pipe';
import { MatButton} from '@angular/material/button';
import { UsPhoneNumberPipe } from '../../utility/us-phone-number.pipe';
import { FeinPipe } from '../../utility/fein.pipe';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router'; // For routerLink
import { MatMenuModule } from '@angular/material/menu';


@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss'],
  imports: [
    CommonModule,
    ValidationContainerComponent,
    NgxDatatableModule,
    DatatableFilterComponent,
    MatIcon,
    MatButton,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    EasternMomemtPipe,
    DateFormatPipe,
    UTCMomentPipe,
    DateTimeFormatPipe,
    MatCheckboxModule,
    RowDetailVisiblePipe,
    YesNoPipe,
    UsPhoneNumberPipe,
    FeinPipe,
    MatCheckboxModule,
    MatSelect,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    MatLabel,
    MatMenuModule,
  ],
})
export class DatatableComponent implements OnInit, AfterViewInit, AfterViewChecked, OnChanges {
  private datatableService = inject(DatatableService);
  private validationService = inject(ValidationService);
  private dialogService = inject(DialogService);
  private environmentService = inject(EnvironmentService);
  private identityService = inject(IdentityService);
  private router = inject(Router);
  private snackbarService = inject(SnackbarService);
  private appInsightsService =inject(AppInsightsService);

  @Input() columns: DatatableColumn[];
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('data-automation-id') dataAutomationId: string;
  @Input() defaultSort: DatatableSort[] = [];
  @Input() defaultFilter: DatatableFilter[];
  @Input() filterByAttributes: DatatableFilter;
  @Input() resetAttributesAfterApply: boolean = true;
  @Input() dataUrl: string;
  @Input() queryObject = {};
  @Input() preventInitialLoad = false;
  @Input() selectRowOnLoad = false;
  @Input() aggregateField: string;
  @Input() exportFileName: string;

  // Look and feel
  @Input() scrollH = false;
  @Input() scrollV = false;
  @Input() pageSize = 10;
  @Input() actionTmpl: TemplateRef<any>;
  @Input() rowDetailTmpl: TemplateRef<any>;
  @Input() rowDetailHeight = 50;
  @Input() rowDetailVisiblePipe: PipeTransform = null;
  @Input() rowClass: any;
  @Input() rowHeight = 50;
  @Input() actionsWidth = 106;
  @Input() multiSelect = false;
  @Input() enableRowTabSelect = false;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  @Input() emptyMessage = 'No Results Found';
  @Input() warningMessage: string;
  @Input() bulkEditActionTmpl: TemplateRef<any>;
  @Input() columnMode = 'force';
  @Input() disableFiltering = false;
  @Input() disableSorting = false;
  @Input() disablePagination = false;
  @Input() actionPermissions: string | string[];
  @Input() isRowActionsVisible: (row: any) => boolean;

  @Output() rowSelected = new EventEmitter<{ selected: any[] }>();
  @Output() dataLoaded = new EventEmitter<any>();
  @Output() requestError = new EventEmitter<any>();
  @Output() aggregateDataLoaded = new EventEmitter<any>();
  @Output() expandableRowDataLoaded = new EventEmitter<any>();

  // Static Templates
  @ViewChild('easternDateTemplate', { static: true }) easternDateTemplate: TemplateRef<any>;
  @ViewChild('easternDateTimeTemplate', { static: true }) easternDateTimeTemplate: TemplateRef<any>;
  @ViewChild('utcDateTemplate', { static: true }) utcDateTemplate: TemplateRef<any>;
  @ViewChild('utcDateTimeTemplate', { static: true }) utcDateTimeTemplate: TemplateRef<any>;
  @ViewChild('utcDateTimeHMSTemplate', { static: true }) utcDateTimeHMSTemplate: TemplateRef<any>;
  @ViewChild('easternDateTimeHMSTemplate', { static: true })
    easternDateTimeHMSTemplate: TemplateRef<any>;
  @ViewChild('currencyTemplate', { static: true }) currencyTemplate: TemplateRef<any>;
  @ViewChild('yesNoTemplate', { static: true }) yesNoTemplate: TemplateRef<any>;
  @ViewChild('feinTemplate', { static: true }) feinTemplate: TemplateRef<any>;
  @ViewChild('entityTemplate', { static: true }) entityTemplate: TemplateRef<any>;
  @ViewChild('transactionTemplate', { static: true }) transactionTemplate: TemplateRef<any>;
  @ViewChild('phoneNumberTemplate', { static: true }) phoneNumberTemplate: TemplateRef<any>;
  @ViewChild('checkboxTemplate', { static: true }) checkboxTemplate: TemplateRef<any>;
  @ViewChild('priorityTagTemplate', { static: true }) priorityTagTemplate: TemplateRef<any>;
  @ViewChild('activeInactiveTemplate', { static: true })
    activeInactiveTemplate: TemplateRef<any>;
  @ViewChild('caseNumberTemplate', { static: true }) caseNumberTemplate: TemplateRef<any>;
  @ViewChild('formNameTemplate', { static: true }) formNameTemplate: TemplateRef<any>;
  @ViewChild('simpleColumnTemplate', { static: true }) simpleColumnTemplate: TemplateRef<any>;
  @ViewChild('defaultTemplate', { static: true }) defaultTemplate: TemplateRef<any>;

  // Display
  headerHeight: number = 50;
  footerHeight: number = 50;
  messages: { emptyMessage: string };
  showExportToCsv: boolean = false;
  hasActionPermission: boolean;

  // Data
  datatableCall$: Subscription;
  rows: any[] = [];
  aggregateData: any[] = [];
  dtColumns: any[];
  columnsByPropTitle: { [propTitle: string]: DatatableColumn };
  wasHidden: boolean = false;

  // Sort
  sorts: DatatableSort[];
  currentSort: any = {};
  externalSortStyle: boolean = false;

  // Filter
  filters: DatatableFilter[];
  @ViewChild('datatableFilters') datatableFilters: DatatableFilterComponent;

  @ViewChild('genericHeaderTmpl', { static: true }) genericHeaderTmpl: TemplateRef<any>;

  @ViewChild('actionHeaderTmpl', { static: true }) actionHeaderTmpl: TemplateRef<any>;

  @ViewChild('ngxDatatable', { static: true }) ngxDatatable: NgxDatableComponent;

  @ViewChild('datatableContainer') datatableContainer: ElementRef;

  // Export To CSV
  @ViewChild('exportToCsvHeaderTmpl', { static: true }) exportToCsvHeaderTmpl: TemplateRef<any>;

  // Counts
  beginningCount = 0;
  endCount = 0;
  filteredCount = 0;
  showTotalCount: boolean;

  // Paging
  currentPage = 1;
  currentComponentWidth: any;
  get pageOffset(): number {
    return this.currentPage - 1;
  }
  minPage: number;
  maxPage: number;
  totalPages: number;
  pages: number[];

  // Service Error Handling
  validationMessages = [];
  defaultErrorMessage = 'An error has occurred. Please try again later.';
  connectionErrorMessage = 'Connection failed. Please try again later.';

  // Selection
  selection: any[] = [];
  @ViewChild('selectAllCheckbox') selectAll: MatCheckbox;

  // Actions
  @ViewChild('detailToggleTmpl', { static: true }) detailToggleTmpl: TemplateRef<any>;
  @ViewChild(NgxDatableComponent) table: NgxDatableComponent;

  
 

  

  ngOnInit() {
    this.validateInputs();
    this.sorts = this.defaultSort?.slice() || [];
    this.externalSortStyle = this.environmentService.isExternalSite;

    const initialSort = this.sorts?.[0]?.property;
    if (initialSort) {
      const columnDef = this.columns.find(
        c =>
          c.sortProperties?.[0] === initialSort ||
          c.property === initialSort ||
          c.sortProperties?.some(sp => sp === initialSort),
      );

      if (columnDef) {
        this.currentSort = {
          [columnDef.property]: this.sorts[0].sortAscending,
        };

        if (columnDef.sortReversed) {
          this.sorts[0].sortAscending = !this.sorts[0].sortAscending;
        }
      }
    }
    if (!(this.preventInitialLoad || this.defaultFilter?.length)) {
      this.reloadTable();
    }

    this.showExportToCsv = this.exportFileName?.length > 0;

    this.determineActionsPermission();
  }

  ngAfterViewInit() {
    // Add Aria roles for improved accessiblity
    const headerCells = this.datatableContainer.nativeElement.getElementsByClassName(
      'datatable-header-cell',
    );
    for (let i = 0; i < headerCells.length; i++) {
      const headerButtons = headerCells[i].getElementsByClassName('mat-button');
      if (headerButtons.length > 0 && headerButtons[0].hasAttribute('data-column-label')) {
        headerCells[i].ariaLabel = headerButtons[0].dataset.columnLabel;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataUrl'] && !changes['dataUrl'].firstChange) {
      this.reloadTable();
    }
    if (changes['actionPermissions'] && !changes['actionPermissions'].firstChange) {
      this.determineActionsPermission();
    }
  }

  ngAfterViewChecked(): void {
    this.resizeTable();
    this.addAriaRoles();
  }

  determineActionsPermission() {
    // Will check for permissions if a string value is provided with length > 0 or if a string array is provided with more than one element
    if (this.actionPermissions?.length > 0) {
      this.hasActionPermission = this.identityService.hasPermissions(this.actionPermissions);
    } else {
      this.hasActionPermission = true;
    }
  }

  // For our sanity
  validateInputs(): any {
    if (this.columns == null) {
      throw new Error('The input "columns" is required');
    }

    this.columnsByPropTitle = {};
    this.columns.forEach(c => (this.columnsByPropTitle[c.property + '|' + (c.title || '')] = c));

    this.enrichWithStaticTemplates(this.columns);
    this.dtColumns = this.datatableService.convertInputColumnsToDtColumns(this.columns);
    this.datatableService.addGenericHeaders(this.dtColumns, this.genericHeaderTmpl);

    this.datatableService.addDetailColumn(
      this.dtColumns,
      this.detailToggleTmpl,
      this.rowDetailTmpl,
    );

    if (this.dataUrl == null) {
      throw new Error('The input "dataUrl" is required');
    }

    this.headerHeight = this.hideHeader ? 0 : this.headerHeight;
    this.footerHeight = this.hideFooter ? 0 : this.footerHeight;
    this.setMessage();
  }

  enrichWithStaticTemplates(columns: DatatableColumn[]) {
    for (const column of columns) {
      if (column.template instanceof TemplateRef) {
        if (this.scrollH && !column.width) {
          column.width = DatatableColumnWidth.default;
        }
        continue;
      }

      switch (column.template) {
        case DatatableStaticTemplateType.EasternDateTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.small;
          }
          column.template = this.easternDateTemplate;
          break;
        case DatatableStaticTemplateType.EasternDateTimeTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.small;
          }
          column.template = this.easternDateTimeTemplate;
          break;
        case DatatableStaticTemplateType.UtcDateTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.small;
          }
          column.template = this.utcDateTemplate;
          break;
        case DatatableStaticTemplateType.UtcDateTimeTemplate:
          column.template = this.utcDateTimeTemplate;
          break;
        case DatatableStaticTemplateType.UtcDateTimeHMSTemplate:
          column.template = this.utcDateTimeHMSTemplate;
          break;
        case DatatableStaticTemplateType.EasternDateTimeHMSTemplate:
          column.template = this.easternDateTimeHMSTemplate;
          break;
        case DatatableStaticTemplateType.CurrencyTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.small;
          }
          column.template = this.currencyTemplate;
          break;
        case DatatableStaticTemplateType.YesNoTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.small;
          }
          column.template = this.yesNoTemplate;
          break;
        case DatatableStaticTemplateType.FeinTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.medium;
          }
          column.template = this.feinTemplate;
          break;
        // This needs to be implemented in datatable-component.html
        // case DatatableStaticTemplateType.TransactionTemplate:
        //   column.template = this.transactionTemplate;
        //   break;
        case DatatableStaticTemplateType.EntityTemplate:
          column.template = this.entityTemplate;
          break;
        case DatatableStaticTemplateType.CheckboxTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.tiny;
          }
          column.template = this.checkboxTemplate;
          break;
        case DatatableStaticTemplateType.PhoneNumberTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.medium;
          }
          column.template = this.phoneNumberTemplate;
          break;
        case DatatableStaticTemplateType.PriorityTagTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.small;
          }
          column.template = this.priorityTagTemplate;
          break;
        case DatatableStaticTemplateType.ActiveInactiveTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.small;
          }
          column.template = this.activeInactiveTemplate;
          break;
        case DatatableStaticTemplateType.CaseNumberTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.medium;
          }
          column.template = this.caseNumberTemplate;
          break;
        case DatatableStaticTemplateType.FormNameTemplate:
          if (!column.width) {
            column.width = DatatableColumnWidth.xl;
          }
          column.template = this.formNameTemplate;
          break;
        case DatatableStaticTemplateType.None:
        default:
          if (this.scrollH && !column.width) {
            column.width = DatatableColumnWidth.default;
          }
          column.template = this.defaultTemplate;
          break;
      }
    }
  }

  resizeTable() {
    if (this.datatableContainer.nativeElement.clientWidth !== this.currentComponentWidth) {
      this.currentComponentWidth = this.datatableContainer.nativeElement.clientWidth;
      this.table.recalculate();
      this.table.recalculateColumns();
    }

    // TODO: Remove this code after ngx-datatable issue has been resolved
    const isHidden = !this.datatableContainer.nativeElement.offsetParent;
    if (isHidden !== this.wasHidden) {
      if (!isHidden) {
        const div = this.datatableContainer.nativeElement.querySelector('div.datatable-row-center');
        div.style.transform = null;
      }
      this.wasHidden = isHidden;
    }
  }

  reloadTable(_queryObj?: object) {
    // Reset the selected values
    this.resetSelected();
    // Setup payload
    const dtRequest: DatatableRequest = {
      pageOffset: this.pageOffset,
      pageSize: this.pageSize,
      sorts: this.sorts,
      filters: this.filters,
      utcOffsetMinutes: moment().utcOffset(),
      aggregateField: this.aggregateField,
    };
    // Add Sorts

    // Use Payload
    // Update requesting with Query Object
    const dtRequestPayload = Object.assign(_queryObj ? _queryObj : this.queryObject, dtRequest);
    //ensure that ignore paging is false when reloading the table
    dtRequestPayload.ignorePaging = false;
    // Http Request
    this.setMessage('Loading data...');
    if (this.datatableCall$ && !this.datatableCall$.closed) {
      this.datatableCall$.unsubscribe();
    //   this.appInsightsService.trackTrace(
    //     `Reloaded datatable - potential duplicate API call. Data URL: ${this.dataUrl}. Route: ${this.router.url}`,
    //   );

      this.appInsightsService.trackTrace(
        `Reloaded datatable - potential duplicate API call. Data URL: ${this.dataUrl}. Route: ${this.router.url}`,
      );

    }
    this.datatableCall$ = this.datatableService
      .getDatatable(this.dataUrl, dtRequestPayload)
      .subscribe(
        response => {
          this.validationMessages = [];
          // Set data
          this.rows = response.data;

          // Set aggregate data
          this.aggregateData = response.aggregatedData;

          // Counts
          const counts = this.datatableService.getCounts(
            response.total,
            this.currentPage,
            this.pageSize,
          );
          this.filteredCount = counts.filteredCount;
          this.beginningCount = counts.beginningCount;
          this.endCount = counts.endCount;

          // Paging
          const pages = this.datatableService.getPages(
            this.filteredCount,
            this.currentPage,
            this.pageSize,
          );
          this.totalPages = pages.totalPages;
          this.minPage = pages.minPage;
          this.maxPage = pages.maxPage;
          this.pages = pages.pagesArray;

          // Actions column
          this.updateActionColumnDefinition();

          this.dataLoaded.emit({ rows: this.rows });
          this.aggregateDataLoaded.emit(this.aggregateData);
          if (this.selectRowOnLoad) {
            this.selectedRow({ selected: [this.rows[0]] });
          }
          this.setMessage();

          this.addAriaRoles();
        },
        (error: HttpErrorResponse) => {
          this.requestError.emit();
          this.reset();
          let errorResponse = [];
          this.validationMessages = [];
          this.setMessage();
          this.setEmptyPaging();
          switch (error.status) {
            case 0:
              this.validationMessages = [
                {
                  type: 'Exception',
                  message: this.connectionErrorMessage,
                },
              ];
              this.snackbarService.openSnackBarFailure('Connection Failed.');
              break;
            case 400: {
              const messages = this.validationService.getErrorResponseMessages(error);
              if (messages?.[0].length) {
                this.setMessage(messages[0]);
              } else {
                this.validationMessages = messages;
              }
              break;
            }
            case 500:
              errorResponse = this.validationService.getErrorResponseMessages(error);
              this.validationMessages = [
                {
                  type: 'Exception',
                  message:
                    errorResponse?.[1]?.developerMessage?.exception?.message ??
                    this.defaultErrorMessage,
                },
              ];
              break;
            default:
              this.validationMessages = [
                {
                  type: 'Exception',
                  message: this.defaultErrorMessage,
                },
              ];
              break;
          }
        },
      );
  }

  addAriaRoles() {
    // Add Aria roles for improved accessiblity
    const bodyRows = this.datatableContainer.nativeElement.getElementsByClassName(
      'datatable-body-row',
    );
    for (let i = 0; i < bodyRows.length; i++) {
      const prevRole = bodyRows[i].getAttribute('role');
      if (prevRole !== 'row') {
        bodyRows[i].setAttribute('role', 'row');
      }
      if (this.enableRowTabSelect) {
        if (bodyRows[i].tabIndex !== 0) {
          bodyRows[i].tabIndex = 0;
        }
        if (bodyRows[i].ariaLabel !== 'Select Row') {
          bodyRows[i].ariaLabel = 'Select Row';
        }
      }
    }
  }

  updateActionColumnDefinition() {
    const hasRowWithActionVisible = this.isRowActionsVisible
      ? this.rows.some(this.isRowActionsVisible)
      : true;
    const showActions = this.hasActionPermission && hasRowWithActionVisible;
    this.dtColumns = this.datatableService.removeActionColumn(this.dtColumns);

    if (this.actionTmpl != null && showActions) {
      this.dtColumns = this.datatableService.addActionColumn(
        this.dtColumns,
        this.actionHeaderTmpl,
        this.actionTmpl,
        this.actionsWidth,
      );
    }
    this.ngxDatatable.recalculateColumns();
  }

  reset() {
    // Reset Sorts
    this.currentSort = {};
    this.sorts = this.defaultSort;
    this.beginningCount = 0;
    this.endCount = 0;
    this.filteredCount = 0;
    this.currentPage = 1;
    this.rows = [];
  }

  tableEmpty() {
    return this.rows.length === 0;
  }

  selectedRow(event: { selected: any[] }) {
    if (this.selectAll && event.selected.length < this.rows.length) {
      this.selectAll.checked = false;
    }
    this.selection = event.selected;
    this.rowSelected.emit(event);
  }

  selectedAll(isChecked: boolean) {
    this.selection = isChecked ? Array.from(this.rows) : [];
    this.rowSelected.emit({ selected: this.selection });
  }

  resetSelected() {
    this.selection = [];
    if (this.selectAll) {
      this.selectAll.checked = false;
    }
  }

  clearData() {
    this.rows = [];
  }

  // Filtering
  filtersChanged(filters: DatatableFilter[]) {
    this.filters = filters;
    this.currentPage = 1;
    this.reloadTable();
  }

  resetFilters() {
    this.datatableFilters.resetFilters();
  }

  // Sorting
  sorted(event: any) {
    this.sort(event);
  }

  sort(event: any) {
    if (!this.disableSorting) {
      this.updateSorts(event.column.prop);
      this.currentPage = 1;
      this.reloadTable();
    }
  }

  updateSorts(newColumnSortProp: string): any {
    const columnDef = this.columns.find(c => c.property === newColumnSortProp);

    this.sorts = [];
    let newSortAscending;

    if (this.currentSort[newColumnSortProp] == null) {
      newSortAscending = true;
    } else {
      newSortAscending = !this.currentSort[newColumnSortProp];
    }

    if (columnDef.sortProperties?.length >= 1) {
      columnDef.sortProperties.forEach(sortProp => {
        this.sorts.push({
          property: sortProp,
          sortAscending: newSortAscending,
        });
      });
    } else {
      this.sorts.push({
        property: newColumnSortProp,
        sortAscending: columnDef.sortReversed ? !newSortAscending : newSortAscending,
      });
    }

    this.currentSort = {
      [newColumnSortProp]: newSortAscending,
    };
  }

  // Paging

  gotoPage(pageNumber: number) {
    const reload = this.currentPage !== pageNumber;
    this.currentPage = pageNumber;
    if (reload) {
      this.reloadTable();
    }
  }

  firstPage() {
    this.gotoPage(1);
  }

  nextPage() {
    this.gotoPage(Math.min(this.currentPage + 1, this.maxPage));
  }

  prevPage() {
    this.gotoPage(Math.max(this.currentPage - 1, this.minPage));
  }

  lastPage() {
    this.gotoPage(Math.ceil(this.filteredCount / this.pageSize));
  }

  changedPageSize() {
    this.currentPage = 1;
    this.reloadTable();
  }

  // Detail
  toggleDetail(row: any, event) {
    this.table.rowDetail.toggleExpandRow(row);
    this.expandableRowDataLoaded.emit(row);
    event.stopPropagation();
  }

  // Export Data to CSV
  exportData(_queryObj?: object) {
    this.reloadTable();

    this.resetSelected();
    // Setup payload
    const dtRequest: DatatableRequest = {
      pageOffset: this.pageOffset,
      pageSize: this.pageSize,
      sorts: this.sorts,
      filters: this.filters,
      utcOffsetMinutes: moment().utcOffset(),
      aggregateField: this.aggregateField,
      ignorePaging: true,
    };
    // Add Sorts

    // Use Payload
    // Update requesting with Query Object
    const dtRequestPayload = Object.assign(_queryObj ? _queryObj : this.queryObject, dtRequest);

    this.datatableService.getDatatableAsCsv(this.dataUrl, dtRequestPayload).subscribe(response => {
      const data = new Blob([response], { type: 'text/csv' });
      fileSaver.saveAs(data, this.getCsvName());

      if (this.filteredCount > 10000) {
        this.openExportModal();
      }
    });
  }

  onCheckBoxChange(row) {
    const priorSelectionLength = this.selection.length;
    this.selection = this.selection.filter(x => x !== row);
    if (priorSelectionLength === this.selection.length) {
      this.selection.push(row);
    }
    this.rowSelected.emit({ selected: this.selection });
  }

  openExportModal() {
    const data: GenericDialogData = {
      title: 'Notification',
      body:
        'The data you are exporting exceeds the maximum allowable amount of rows.  The first 10,000 rows will be returned in the file, starting with the most recent.',
    };
    this.dialogService.showGenericDialog(data);
  }

  getCsvName() {
    const today = moment();
    return (
      this.exportFileName +
      '_Export_' +
      today.format('MMDDYYYY') +
      '_' +
      today.format('hhmmss') +
      '.csv'
    );
  }

  // Conditional Classes

  firstPageClass() {
    return { disabled: this.minPage === this.maxPage || this.currentPage === 1 };
  }

  prevPageClass() {
    return { disabled: this.currentPage === this.minPage };
  }

  pageClass(pageNumber: number, isLast) {
    return { active: pageNumber === this.currentPage, 'me-1': isLast };
  }

  nextPageClass() {
    return { disabled: this.currentPage === this.maxPage };
  }

  lastPageClass() {
    return {
      disabled: this.minPage === this.maxPage || this.currentPage === this.totalPages,
    };
  }

  setEmptyPaging() {
    this.filteredCount = 0;
    this.beginningCount = 0;
    this.endCount = 0;
    this.totalPages = 0;
    this.minPage = 0;
    this.maxPage = 0;
    this.pages = [];
  }

  // Handle tab focus on header sort buttons and set horizontal scroll of table
  @HostListener('focusin', ['$event'])
  headerFocusInHandler(evt) {
    if (this.scrollH && evt.target.matches('.datatable-header-cell .mat-button')) {
      const header = this.datatableContainer.nativeElement.getElementsByClassName(
        'datatable-header',
      )[0];
      header.scrollLeft = 0;

      const cellElement = evt.target.parentElement.parentElement;
      if (cellElement) {
        const offsetLeft = cellElement.offsetLeft;
        const tableBody = this.datatableContainer.nativeElement.getElementsByClassName(
          'datatable-body',
        )[0];

        if (offsetLeft + cellElement.clientWidth > tableBody.scrollLeft + header.clientWidth) {
          tableBody.scrollLeft = offsetLeft - (header.clientWidth - cellElement.clientWidth);
        } else if (offsetLeft < tableBody.scrollLeft) {
          tableBody.scrollLeft = offsetLeft;
        }
      }
    }
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === KeyConstant.shift) {
      document.documentElement.style.setProperty('--user-select-option', 'none');
    }
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    if (event.key === KeyConstant.shift) {
      document.documentElement.style.setProperty('--user-select-option', 'all');
    }
  }

  private setMessage(message?: string) {
    this.messages = {
      emptyMessage: message ?? this.emptyMessage,
    };
  }
}
